import OrderItems from "views/Order/OrderItems";
import LocationSelector from "components/LocationSelector";
import { useContext } from "react";
import { AppParamsContext } from "contexts/AppParamsContext";

export default function Menu() {
  const { appParams } = useContext(AppParamsContext);
  return (
    <div className="flex flex-col overflow-hidden grow h-full min-h-full">
      {appParams?.order?.orderLocationSelector && <LocationSelector />}
      <OrderItems readOnly={true} />
    </div>
  );
}
